import { html } from 'lit';
import { accountPath } from '../accounts.js';
import { UserAccountBilling } from './account-billing.js';

export class UserAccountBillingHistory extends UserAccountBilling
{
   static subpage = { id: 'history', label: 'Billing history' };
   static detailedHistory = true;

   get description()
   {
      return this.team ? `Invoices, adjustments and subscription changes for ${this.team.name}.` : '';
   }

   get pageActions()
   {
      return [{ id: 'billing', title: 'Back to billing', label: 'Back to billing', href: accountPath('billing', this.account),
         icon: 'fa-solid fa-arrow-left', variant: 'outline-secondary' }, ...super.pageActions];
   }

   get body()
   {
      return html`${this.invoices}${this.activityPanel}`;
   }
}
customElements.define('user-account-billing-history', UserAccountBillingHistory);
